import type { CreateStoreResult } from '@ms/yammer-data';
import { createStore } from '@ms/yammer-data';
import { i18nReducer } from '@ms/yammer-i18n-react';
import type { ReducersMapObject } from 'redux';

import widgetConfigurationReducer from '../../../state/reducer';
import type { YammerEmbedState } from '../../../state/types';
import { persistConfig } from '../../persistedState';

export const createYammerEmbedStore: () => CreateStoreResult<YammerEmbedState> = () => {
  const reducers: ReducersMapObject<Partial<YammerEmbedState>> = {
    i18n: i18nReducer,
    widgetConfiguration: widgetConfigurationReducer,
  };

  return createStore<YammerEmbedState>({ reducers, persistConfig });
};
